var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('div',{staticClass:"offer-controls"},[_c('v-btn',{attrs:{"loading":_vm.actionLoading,"small":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleOffer()}}},[_vm._v(_vm._s(_vm.actionText))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }